module.exports = __webpack_public_path__ + "img/47.bb39bf6c.jpg";